import { render, staticRenderFns } from "./ContactUs.vue?vue&type=template&id=05be8545&"
import script from "./ContactUs.js?vue&type=script&lang=js&"
export * from "./ContactUs.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports